import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      ref: "keyButton",
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDown && _ctx.handleDown(...args))),
      onMouseup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUp && _ctx.handleUp(...args))),
      class: "tw-w-[50px] tw-h-[50px] tw-bg-primary tw-text-mainbg1 tw-m-[3px] tw-rounded-[3px] tw-pt-[7px]"
    }, _toDisplayString(_ctx.value), 545)
  ]))
}